import React, { useState, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { EventType } from "pages/statuses/EventType";
import { Booking } from "api/entities/Booking";
import { ConfirmParts } from "pages/booking/dialogParts/ConfirmParts";
import { DisplayDate } from "pages/booking/dialogParts/DisplayDate";
import { BookingApi } from "api/BookingApi";
import * as CommonConstants from "utilities/CommonConstants";
import { BookingTypeName } from "pages/booking/dialogParts/BookingTypeName";
import { BookingUtil } from "pages/booking/BookingUtil";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        date: {
            marginTop: theme.spacing(5),
            marginLeft: theme.spacing(5),
            fontSize: `25px`,
        },
    })
);

interface Props {
    match: any;
}

export const Confirm: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [targetBooking, setTargetBooking] = useState<EventType>({
        id: ``,
        title: ``,
        start: new Date(),
        end: new Date(),
        color: ``,
        display: ``,
        classNames: [],
        groupId: ``,
        bookingTypeId: 0,
        status: 0,
        subscriberName: ``,
        subscriberLaboratoryId: ``,
        subscriberLaboratoryName: ``,
        subscriberMailAddress: ``,
        subscriberMailAddressOption: ``,
        subscriberTel: ``,
        subscriberMemo: ``,
        bookingDetails: [],
    });

    useEffect(() => {
        const execute = async () => {
            // 予約情報を取得
            let result = await BookingApi.getBookingForConfirmByEncryptedId(props.match.params.id);

            if (result?.status === 200) {
                const bookingEntities: Booking = result.data;
                const bookings = convertBookings(bookingEntities);

                let booking: EventType = {
                    id: bookings.id.toString(),
                    title: ``,
                    start: bookings.start,
                    end: bookings.end,
                    color: bookings.color,
                    display: CommonConstants.EVENT_DISPLAY_BOOKING,
                    classNames: bookings.classNames,
                    groupId: `booking`,
                    bookingTypeId: bookings.bookingTypeId,
                    status: bookings.status,
                    subscriberName: bookings.subscriberName,
                    subscriberLaboratoryId: bookings.subscriberLaboratoryId,
                    subscriberLaboratoryName: bookings.subscriberLaboratoryName,
                    subscriberMailAddress: bookings.subscriberMailAddress,
                    subscriberMailAddressOption: bookings.subscriberMailAddressOption,
                    subscriberTel: bookings.subscriberTel,
                    subscriberMemo: bookings.subscriberMemo,
                    bookingDetails: bookings.bookingDetails,
                };
                setTargetBooking(booking);
            }
        };
        execute();
    }, [props.match.params.id]);

    /**
     * DBから取得した予約情報を、イベント情報として持ち回せるよう詰め替える
     * @param bookingEntities DBから取得した予約情報
     * @return 予約イベント
     */
    const convertBookings = (bookingEntities: Booking): EventType => {
        let bookings: EventType = {
            id: bookingEntities.id.toString(),
            title: ``,
            start: new Date(bookingEntities.bookingStartTime),
            end: new Date(bookingEntities.bookingEndTime),
            color: `${BookingUtil.getColorByBookingType(bookingEntities.bookingTypeId)}`,
            display: CommonConstants.EVENT_DISPLAY_BOOKING,
            classNames: [`${BookingUtil.getClassNameByBookingType(bookingEntities.bookingTypeId)}`],
            groupId: `booking`,
            bookingTypeId: bookingEntities.bookingTypeId,
            status: bookingEntities.status,
            subscriberName: bookingEntities.subscriberName,
            subscriberLaboratoryId: bookingEntities.subscriberLaboratoryId,
            subscriberLaboratoryName: bookingEntities.subscriberLaboratoryName,
            subscriberMailAddress: bookingEntities.subscriberMailAddress,
            subscriberMailAddressOption: bookingEntities.subscriberMailAddressOption,
            subscriberTel: bookingEntities.subscriberTel,
            subscriberMemo: bookingEntities.subscriberMemo,
            bookingDetails: bookingEntities.bookingDetails,
        };
        return bookings;
    };

    return (
        <div>
            <div className={classes.date}>
                <DisplayDate booking={targetBooking} />
                <BookingTypeName booking={targetBooking} />
            </div>
            <ConfirmParts booking={targetBooking} />
        </div>
    );
};
